import { SET_WAREHOUSES_DATA } from "../actionTypes";
import { Warehouse } from "../../Types/PrismaSwift";

export const setWarehousesDataAction = (payload: Warehouse[] | []) => {
  return {
    type: SET_WAREHOUSES_DATA as typeof SET_WAREHOUSES_DATA,
    payload: payload,
  };
};
